'use client'

import { ComponentProps, ElementType } from 'react'

import { LoadingSpinner, PolymorphicComponentProps } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../app/_providers/TranslationProvider.client'

import { LoadingSpinnerWrapper, StyledCtaButton } from './styles'

export type CtaButtonProps<C extends ElementType = 'button'> = PolymorphicComponentProps<
  C,
  ComponentProps<typeof StyledCtaButton>
>

/**
 * @deprecated This component is deprecated. Use SubmitButton from @syconium/little-miss-figgy instead.
 */
export const CtaButton = function CtaButtonTemplate<C extends ElementType = 'button'>({
  children,
  isProcessing,
  ref,
  ...rest
}: CtaButtonProps<C>) {
  const {
    magnolia: {
      general: { loading },
    },
  } = useTranslation()
  return (
    <StyledCtaButton ref={ref} isProcessing={isProcessing} size='large' {...rest}>
      {isProcessing && (
        <LoadingSpinnerWrapper>
          <LoadingSpinner label={loading} />
        </LoadingSpinnerWrapper>
      )}
      {children}
    </StyledCtaButton>
  )
}
